// Copyright (c) 2017 Deere & Company

import ReimbursementSummaryAllAccounts from '../../reimbursement-summary/details/all-accounts';

export default {
    component: ReimbursementSummaryAllAccounts,
    name: 'ALL_ACCOUNTS',
    path: 'all'
};



// WEBPACK FOOTER //
// ./src/routes/reimbursement-summary/all-accounts.js